import React, { useState, useEffect } from 'react';
import { useDataProvider } from 'react-admin';
import { IconButton, Badge } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsDropdown from './NotificationsDropdown';

const NotificationsButton = () => {
  const dataProvider = useDataProvider();
  const [unreadCount, setUnreadCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);

  // Fetch unread notifications count
  useEffect(() => {
    let isMounted = true;

    const fetchUnreadCount = async (retryCount = 0) => {
      try {
        const response = await dataProvider.getList('notifications', {
          pagination: { page: 1, perPage: 1 },
          sort: { field: 'created_at', order: 'DESC' },
          filter: { is_web_read: false },
        });
        if (isMounted) {
          setUnreadCount(response.total);
        }
      } catch (error) {
        console.error('Error fetching unread count:', error);
        
        // Retry up to 2 times with exponential backoff
        if (retryCount < 2 && isMounted) {
          const delay = Math.pow(2, retryCount) * 1000; // 1s, 2s
          setTimeout(() => {
            fetchUnreadCount(retryCount + 1);
          }, delay);
        } else {
          // Set unread count to 0 if all retries fail
          if (isMounted) {
            setUnreadCount(0);
          }
        }
      }
    };

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 60000); // Poll every minute

    return () => {
      clearInterval(interval);
      isMounted = false;
    };
  }, [dataProvider]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    // Unread count will be reset in NotificationsDropdown after marking all as read
    setUnreadCount(0);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleMenuOpen}>
        <Badge badgeContent={unreadCount} color="secondary">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <NotificationsDropdown anchorEl={anchorEl} onClose={handleMenuClose} />
    </>
  );
};

export default NotificationsButton;
